// extracted by mini-css-extract-plugin
export default {"zoomIn":"zoomIn___YXjLztS","zoomOut":"zoomOut___YXjLztS"};